import React from 'react';

import { MdModeEdit, MdDelete, MdCheck } from 'react-icons/md';

import history from '~/services/history';

const columnProstata = () => {
  const editarLinha = (id, data) => {
    history.push({
      pathname: `/formulario-linhas-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        idRecord: Number(id),
        id: Number(id),
      },
    });
  };

  const deletarLinha = (id, data) => {
    history.push({
      pathname: `/linha-de-cuidado/${data.linhaDeCuidadoValue}`,
      state: {
        periodo: data.periodoSelecionado,
        indicador: data.linhaDeCuidadoValue,
        indicadorNome: data.linhaDeCuidado,
        deleteLinha: Number(id),
      },
    });
  };

  return [
    {
      title: 'Número do registro',
      dataIndex: 'num_registro_pros',
      key: 'num_registro_pros',
      width: 170,
      sorter: (a, b) => a.num_registro_pros - b.num_registro_pros,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: 'Identificador do paciente',
      dataIndex: 'identificadordoPaciente',
      key: 'identificadordoPaciente',
      width: 210,
    },

    {
      title: 'Completo',
      key: 'completo',
      dataIndex: 'completo',
      width: 120,
      sorter: (a, b) => a.completo - b.completo,
      sortDirections: ['descend', 'ascend'],
      render: (id, data) => {
        return (
          <div>{data.completo && <MdCheck size={20} color="#74a50a" />}</div>
        );
      },
    },
    {
      title: '',
      key: 'id',
      dataIndex: 'id',
      width: 210,
      render: (id, data) => {
        return (
          <div className="botoesGrid">
            <button type="button" onClick={() => editarLinha(id, data)}>
              <MdModeEdit size={18} />
              Editar
            </button>
            <button
              type="button"
              className="btn-remove"
              onClick={() => deletarLinha(id, data)}
            >
              <MdDelete size={18} />
              Excluir
            </button>
          </div>
        );
      },
    },

    {
      title: 'Data de nascimento',
      dataIndex: 'dn_pros',
      key: 'dn_pros',
      width: 120,
    },
    {
      title: 'Convênio do paciente',
      dataIndex: 'convenio_pros_descritivo',
      key: 'convenio_pros',
      width: 120,
    },
    {
      title: 'Data da entrada do paciente na instituição',
      dataIndex: 'entrada_data_pros',
      key: 'entrada_data_pros',
      width: 170,
    },
    {
      title: 'Hora da entrada do paciente na instituição',
      dataIndex: 'entrada_hora_pros',
      key: 'entrada_hora_pros',
      width: 170,
    },
    {
      title: 'Nível de PSA total no diagnóstico',
      dataIndex: 'psa_total_pros',
      key: 'psa_total_pros',
      width: 170,
    },
    {
      title: 'Nível de PSA livre no diagnóstico',
      dataIndex: 'psa_livre_pros',
      key: 'psa_livre_pros',
      width: 170,
    },
    {
      title: 'Amostra 1 de Gleason no diagnóstico',
      dataIndex: 'gleason1_pros',
      key: 'gleason1_pros',
      width: 170,
    },
    {
      title: 'Amostra 2 de Gleason no diagnóstico',
      dataIndex: 'gleason2_pros',
      key: 'gleason2_pros',
      width: 170,
    },
    {
      title: 'Escore de Gleason no diagnóstico',
      dataIndex: 'gleason_pros',
      key: 'gleason_pros',
      width: 170,
    },
    {
      title: 'Escore ASA pré-operatório',
      dataIndex: 'asa_pros_descritivo',
      key: 'asa_pros',
      width: 130,
    },
    {
      title: 'Procedimento cirúrgico realizado',
      dataIndex: 'cirurgia_tipo_pros_descritivo',
      key: 'cirurgia_tipo_pros',
      width: 150,
    },
    {
      title: 'Via de acesso – técnica cirúrgica',
      dataIndex: 'cirurgia_via_pros_descritivo',
      key: 'cirurgia_via_pros',
      width: 150,
    },
    {
      title: 'Tipo histológico de acordo com a OMS',
      dataIndex: 'tipo_oms_pros_descritivo',
      key: 'tipo_oms_pros',
      width: 150,
    },
    {
      title: 'Grau histológico de acordo com o escore de Gleason',
      dataIndex: 'grau_gleason_pros_descritivo',
      key: 'grau_gleason_pros',
      width: 170,
    },
    {
      title: 'Extensão extraprostática',
      dataIndex: 'extensao_pros_descritivo',
      key: 'extensao_pros',
      width: 120,
    },
    {
      title: 'Invasão da vesícula seminal',
      dataIndex: 'invasao_pros_descritivo',
      key: 'invasao_pros',
      width: 100,
    },
    {
      title: 'Status das margens',
      dataIndex: 'status_margens_pros_descritivo',
      key: 'status_margens_pros',
      width: 100,
    },
    {
      title: 'Estadiamento patológico TNM',
      dataIndex: 'estadiamento_pros_descritivo',
      key: 'estadiamento_pros',
      width: 140,
    },
    {
      title: 'Número de linfonodos ressecados',
      dataIndex: 'linfonodos_pros_descritivo',
      key: 'linfonodos_pros',
      width: 100,
    },
    {
      title: 'Estadiamento TNM registrado em prontuário',
      dataIndex: 'tnm_prontuario_pros_descritivo',
      key: 'tnm_prontuario_pros',
      width: 150,
    },
    {
      title: 'Características do tumor primário (T)',
      dataIndex: 't_pros_descritivo',
      key: 't_pros',
      width: 140,
    },
    {
      title:
        'Características dos linfonodos das cadeias de drenagem linfática do órgão em que o tumor se localiza (N)',
      dataIndex: 'n_pros',
      key: 'n_pros',
      width: 210,
    },
    {
      title: 'Presença ou ausência de metástases a distância (M)',
      dataIndex: 'm_pros_descritivo',
      key: 'm_pros',
      width: 150,
    },
    {
      title: 'Pacientes em medidas de conforto ou cuidados paliativos',
      dataIndex: 'paliativos_pros_descritivo',
      key: 'paliativos_pros',
      width: 190,
    },
    {
      title: 'Evento cardiovascular',
      dataIndex: 'cardio_pros_descritivo',
      key: 'cardio_pros',
      width: 130,
    },
    {
      title: 'Tromboembolismo pulmonar / trombose venosa profunda',
      dataIndex: 'trombo_pros_descritivo',
      key: 'trombo_pros',
      width: 170,
    },
    {
      title: 'Transfusão sanguínea',
      dataIndex: 'transfusao_pros_descritivo',
      key: 'transfusao_pros',
      width: 100,
    },

    {
      title: 'Paciente teve diagnóstico de COVID-19 durante a internação',
      dataIndex: 'covid_prostata',
      key: 'covid_prostata',
      width: 210,
    }, //

    {
      title: 'Motivo da saída hospitalar',
      dataIndex: 'saida_motivo_pros_descritivo',
      key: 'saida_motivo_pros',
      width: 120,
    },
    {
      title: 'Data da saída hospitalar',
      dataIndex: 'saida_data_pros',
      key: 'saida_data_pros',
      width: 120,
    },
    {
      title: 'Hora da saída hospitalar',
      dataIndex: 'saida_hora_pros',
      key: 'saida_hora_pros',
      width: 100,
    },
  ];
};

export default columnProstata;
